/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import completed AD generation jobs into your project." |
*
* @param {Ad_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_description = /** @type {((inputs?: Ad_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importez les tâches de génération de publicités terminées dans votre projet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren Sie abgeschlossene AD-Generierungsaufträge in Ihr Projekt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa i processi di generazione di annunci pubblicitari completati nel tuo progetto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте завершенные задания по генерации AD в свой проект.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importa los trabajos de generación de anuncios completados a tu proyecto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将已完成的广告生成任务导入到您的项目中。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("完了した広告生成ジョブをプロジェクトにインポートします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण हो चुके AD जनरेशन जॉब्स को अपने प्रोजेक्ट में आयात करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe os trabalhos de geração de anúncios (AD) concluídos para o seu projeto.")
	return /** @type {LocalizedString} */ ("Import completed AD generation jobs into your project.")
});